import { Form, Headline } from '@servicetitan/design-system';
import { UseFormReturn, FormProvider, useFieldArray } from 'react-hook-form';
import ContactMethodForm from '@components/forms/components/ContactMethodForm/ContactMethodForm';
import { EditContactsValidationType } from '../../../validations';

type EditContactsDrawerPageProps = {
  formMethods: UseFormReturn<EditContactsValidationType>;
  onSubmit: (
    event: React.SyntheticEvent<Element, Event>,
    data: EditContactsValidationType,
  ) => void;
};

const EditContactsDrawerPage = ({
  formMethods,
  onSubmit,
}: EditContactsDrawerPageProps) => {
  const { control } = formMethods;

  const fieldArray = useFieldArray({
    control,
    name: `editContacts.contacts`,
  });

  const { update, append, remove, fields } = fieldArray;

  return (
    <>
      <Headline className='m-b-4' size='small'>
        Contact Methods
      </Headline>
      <FormProvider {...formMethods}>
        <Form onSubmit={onSubmit}>
          <ContactMethodForm
            formFieldPrefix='editContacts'
            update={update}
            append={append}
            remove={remove}
            contactMethodFields={fields}
          />
        </Form>
      </FormProvider>
    </>
  );
};

export default EditContactsDrawerPage;
